import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { useStore } from "../store";
import { useNavigate } from "react-router";

export const useInsights = () => {
  const navigate = useNavigate();
  const [state] = useStore();

  const configureInsights = (instrumentationKey: string) => {
    const reactPlugin = new ReactPlugin();
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { navigate }
        }
      }
    });

    appInsights.loadAppInsights();
  };

  const setupInsights = () => {
    if (state.settings) {
      if (state.settings.ApplicationInsightsInstrumentationKeyWeb) {
        configureInsights(state.settings.ApplicationInsightsInstrumentationKeyWeb);
      }
    }
  };

  return { setupInsights };
};
